onReady(($) => {
    const pricingTables = $('.pricing-table')
    if (pricingTables.length === 0) {
        return
    }

    // Replace or add UTMs on CTAs
    const utmQueryString = getUTMParameters()
    if (utmQueryString) {
        $('.block  a.cta-button', pricingTables)
            .each((i, link) => replaceLinkParameters(link, utmQueryString))
    }

    $(".pricing-table .blocks")
        .on("mouseover", function () {
            $(".pricing-table .block")
                .removeClass("active");
        });
    $(".pricing-table .blocks")
        .on("mouseout", function () {
            $(".highlight")
                .addClass("active");
        });
    $('.featuresList  p.heading')
        .on("click ", function () {
            if ($(window)
                .width() <= 991) {
                $(this)
                    .next()
                    .slideToggle();
                $(this)
                    .toggleClass('open');
            }
        });
    $('.featureItem.info .icon')
        .on("click", function () {
            if ($(window)
                .width() <= 991) {
                $(this)
                    .parent()
                    .toggleClass('showtool');
                $(this)
                    .siblings('.text')
                    .toggleClass('none');
            }
        });
});
